import React from 'react';
import { useTranslation } from 'react-i18next';
import emptyState from 'Assets/layout/notificationCenter/emptyState.svg';

import './NotificationEmptyState.scss';

export const NotificationEmptyState = () => {
  const { t } = useTranslation();

  return (
    <div styleName="notice-empty">
      <div styleName="notice-empty-image">
        <img src={emptyState} alt={t('T.NC You don’t have any notifications')} />
      </div>
      <div styleName="notice-empty-text">{t('T.NC You don’t have any notifications')}</div>
    </div>
  );
};
